import { createFromIconfontCN } from "@ant-design/icons";
//
import styles from  './style.module.scss'
//
// 添加自定义样式
function MyIcon(props) {
  //
  const {type, fontSize} = props
  // console.log(1200, props);
  return <IconFont type={type} className={styles.icon} aria-hidden="true" 
  style={{
          fontSize,
          left:'99px'
        }}/>;
}
// 阿里图标脚本
const IconFont = createFromIconfontCN({
  scriptUrl: ["//at.alicdn.com/t/c/font_4116934_iirm89woeb.js"],
});
// 主站图标svg
/**
 * 
 * @returns 主站图标svg|站点图标|logo
 */

//
export const IconArticle   = () => <MyIcon type="icon-pic-left" />;       // 文章
export const IconMore      = () => <MyIcon type="icon-ellipsis" />;       // 更多more
export const IconMusicList    = (props) => <IconFont type="icon-musiclist-copy" style={props.style}    aria-hidden="true" />;
export const IconGithub    = (props) => <IconFont type="icon-GitHub" style={{ fontSize: props.fontSize, left:'99px' }}  aria-hidden="true" />;
export const IconGitee     = (props) => <IconFont type="icon-gitee" style={{ fontSize: props.fontSize, left:'99px' }}  aria-hidden="true" />;
export const IconTelegram  = (props) => <IconFont type={"icon-telegram1"} style={{ fontSize: props.fontSize, left:'99px' }}  aria-hidden="true" />;
export const IconAbout     = (props) => <IconFont type={"icon-About"} style={{ fontSize: props.fontSize, left:'99px' }}  aria-hidden="true" />;
export const IconHome      = (props) => <IconFont type={"icon-ziyuan"} style={{ fontSize: props.fontSize, left:'99px' }}  aria-hidden="true" />;
export const IconQQ        = (props) => <IconFont type={"icon-QQ1"} style={{ fontSize: props.fontSize, left:'99px' }}  aria-hidden="true" />;
export const IconWeiXin    = (props) => <IconFont type={"icon-weixin"} style={{ fontSize: props.fontSize, left:'99px' }}  aria-hidden="true" />;
export const IconUser    = (props) => <IconFont type={"icon-user"} style={{ fontSize: props.fontSize, left:'99px' }}  aria-hidden="true" />;
export const IconDot    = (props) => <IconFont type={"icon-dian"} style={{ fontSize: props.fontSize, left:'99px' }}  aria-hidden="true" />;
export const IconRefresh    = (props) => <IconFont type={"icon-yunduanshuaxin"} style={props.style}  aria-hidden="true" />;
export const IconCopy    = (props) => <IconFont type={"icon-fuzhi"} style={props.style}  aria-hidden="true" />;
export const IconMenu    = (props) => <IconFont type={"icon-caidan1"} {...props}  aria-hidden="true" />;


//
export const SiteLogo = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="30px"
    height="30px"
    viewBox="0 0 480 480"
    style={{ enableBackground: "new 0 0 480 480" }}
    xmlSpace="preserve"
  >
    {" "}
    <style type="text/css"> {`.st0 { fill: #040000; }`} </style> <defs> </defs>{" "}
    <g>
      <path
        className="st0"
        d="M0.42,479.58V0.42h479.16v479.16H0.42z M288.64,372.74h55.24l0.14-0.3l76.89-265.18h-55.43L316.29,276.8
      l-48.97-168.78l0.22-0.77h-55.92l0.25,0.85l-49.02,168.95l-24.22-83.49l-5.58,0.06l-15.29-52.12l5.74-0.06l-7.5-25.87l-17.79,0.18
      l-2.5-8.51H80.41l2.54,8.67l-6.11,0.06l-2.56-8.73h-15.2l2.83,9.74l13.31-0.14l7.09,24.18l-13.51,0.14l-7.26-25.03l-1.52,0.02
      l59.93,204.31l15.16,52.26h55.44l49.03-169.08L288.64,372.74z M83.44,141.87l2.12-0.02l15.29,52.12l-2.12,0.02L83.44,141.87z
       M100.8,141.69l1.71-0.02l15.29,52.11l-1.71,0.02L100.8,141.69z"
      />
      <path
        className="st0"
        d="M479.16,0.84v478.32H0.84V0.84H479.16 M316.29,275.29l-48.53-167.27l0.03-0.11l0.31-1.07h-1.12h-0.2h-54.36
      h-0.25h-1.12l0.31,1.07l0.06,0.2l-48.58,167.44l-23.73-81.79l-0.18-0.61l-0.64,0.01l-4.94,0.05l-15.04-51.28l4.63-0.05l1.11-0.01
      l-0.31-1.06l-7.26-25.03l-0.18-0.61l-0.64,0.01l-17.15,0.18l-2.32-7.91l-0.18-0.6h-0.63H80.97h-1.12l0.32,1.08l2.23,7.6l-5.23,0.05
      l-2.38-8.13l-0.18-0.6h-0.63H59.65h-1.12l0.31,1.07l2.27,7.82l-0.54,0.01l-1.11,0.01l0.31,1.07l7.34,25.03l15.53,52.95l36.9,125.79
      l15.08,51.96l0.18,0.61h0.63h0.2h14.97h6.99h7.42h25.03h0.2h0.63l0.18-0.61l48.54-167.38l48.57,167.38l0.23,0.61h0.63h54.6h0.63
      l0.18-0.61l76.74-264.64l0.31-1.07h-1.12H365.8h-0.63l-0.18,0.61L316.29,275.29 M74.92,117.28l6.85,23.34l-12.64,0.13l-6.77-23.34
      L74.92,117.28 M102.19,142.1l15.04,51.28l-0.83,0.01l-15.04-51.28L102.19,142.1 M85.24,142.27l15.04,51.28l-1.24,0.01L84,142.28
      L85.24,142.27 M480,0H0v480h480V0L480,0z M316.29,278.31l49.51-170.63h54.55l-76.74,264.64h-0.05h-54.55h-0.05l-49.38-170.17
      l-49.34,170.17h-0.2h-25.03h-7.42h-6.99h-14.97h-0.03h-0.17l-15.08-51.96l-36.9-125.79l-15.53-52.95l-7.34-25.03l0.65-0.01
      l7.26,25.03l14.39-0.15l-7.34-25.02l-13.31,0.14l-2.58-8.89h14.32l2.56,8.74l6.98-0.07l-2.54-8.66h14.41l2.5,8.52l17.79-0.18
      l7.26,25.03l-25.68,0.26l-14.37,0.15l15.53,52.95l2.99-0.03l-15.52-52.92l14.37-0.15l15.52,52.92l2.58-0.03l-15.47-52.75
      l14.37-0.15l15.47,52.75l5.58-0.06l24.54,84.57l49.46-170.46l-0.12-0.43h0.25h54.36h0.2l-0.1,0.34L316.29,278.31L316.29,278.31z"
      />
    </g>
  </svg>
);



